"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingInspectionDetailsDtoInspectionTypeEnum = void 0;
exports.instanceOfListingInspectionDetailsDto = instanceOfListingInspectionDetailsDto;
exports.ListingInspectionDetailsDtoFromJSON = ListingInspectionDetailsDtoFromJSON;
exports.ListingInspectionDetailsDtoFromJSONTyped = ListingInspectionDetailsDtoFromJSONTyped;
exports.ListingInspectionDetailsDtoToJSON = ListingInspectionDetailsDtoToJSON;
exports.ListingInspectionDetailsDtoToJSONTyped = ListingInspectionDetailsDtoToJSONTyped;
/**
 * @export
 */
exports.ListingInspectionDetailsDtoInspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * Check if a given object implements the ListingInspectionDetailsDto interface.
 */
function instanceOfListingInspectionDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    if (!('totalInspectionCount' in value) || value['totalInspectionCount'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    return true;
}
function ListingInspectionDetailsDtoFromJSON(json) {
    return ListingInspectionDetailsDtoFromJSONTyped(json, false);
}
function ListingInspectionDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': (new Date(json['inspectionStartTime'])),
        'inspectionEndTime': (new Date(json['inspectionEndTime'])),
        'inspectionType': json['inspectionType'],
        'listingId': json['listingId'],
        'totalInspectionCount': json['totalInspectionCount'],
        'isActive': json['isActive'],
    };
}
function ListingInspectionDetailsDtoToJSON(json) {
    return ListingInspectionDetailsDtoToJSONTyped(json, false);
}
function ListingInspectionDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'].toISOString(),
        'inspectionEndTime': value['inspectionEndTime'].toISOString(),
        'inspectionType': value['inspectionType'],
        'listingId': value['listingId'],
        'totalInspectionCount': value['totalInspectionCount'],
        'isActive': value['isActive'],
    };
}
